export const ALIGN_HINTS = {
  FRONT: "Acercá y alineá el frente del DNI dentro del recuadro",
  BACK: "Acercá y alineá el dorso del DNI dentro del recuadro",
} as const;

export const HINTS = {
  NO_DOCUMENT: "Ubicá el DNI dentro del recuadro",
  PROCESSING: "Estamos procesando...",
} as const;

export const QUALITY_REASONS = {
  NO_DOCUMENT: HINTS.NO_DOCUMENT,
  SHARPNESS: "La información se ve borrosa. Mantené firme el celular",
  LOW_LIGHT: "Buscá un lugar con más luz",
  TOO_MUCH_LIGHT: "Evitá la luz directa",
  GLARE: "Evitá los reflejos en el DNI",
} as const;

export const SIDE_MESSAGES = {
  EXPECTED_FRONT: "Parece el DORSO. Mostrá el FRENTE (el lado de la foto).",
  EXPECTED_BACK: "Parece el FRENTE. Mostrá el DORSO (lado de la MRZ).",
  BACK_UNREADABLE: "No leo el dorso. Acercá y alineá el pie del documento.",
} as const;

export const OCR_REASONS = {
  FRONT_UNREADABLE:
    "No se reconoce contenido del frente (ni número ni campos del DNI)",
  MRZ_NOT_FOUND: "No se detecta la zona MRZ del dorso",
  MRZ_INVALID: "La MRZ no valida (dígito verificador del documento incorrecto)",
} as const;
